export default __webpack_public_path__ + "static/blob-47-9e0a1bc9aaba80f470ccf9bf351ea558.svg";